import React, { FC } from 'react';

import {
	ErrorRocketIcon,
	EvBodyMedium,
	EvFlexColumn,
	EvHeadingSmall,
	EvIcon,
	TEXT_COLOR
} from '@evinced-private/ui-common';

import { LABEL_MANAGEMENT_PANEL_VALUES_EMPTY_STATE_DAID } from 'data-automation-ids/LabelManagementAutomationIds';

import { VALUES_TABLE_LABELS } from './ValuesTable.labels';

export const ValuesTableEmptyState: FC = () => (
	<EvFlexColumn
		dataAutomationId={LABEL_MANAGEMENT_PANEL_VALUES_EMPTY_STATE_DAID}
		align="CENTER"
		justify="CENTER"
		padding={['XXXLARGE', 'XXXLARGE']}
	>
		<EvIcon icon={ErrorRocketIcon} title={VALUES_TABLE_LABELS.EMPTY_STATE_TITLE} />
		<EvHeadingSmall as="p" color={TEXT_COLOR.CONTENT_2}>
			{VALUES_TABLE_LABELS.EMPTY_STATE_TITLE}
		</EvHeadingSmall>
		<EvBodyMedium color={TEXT_COLOR.CONTENT_3}>
			{VALUES_TABLE_LABELS.EMPTY_STATE_DESCRIPTION}
		</EvBodyMedium>
	</EvFlexColumn>
);
